/**
 * Browsers open a file that is dropped where no drop zone handles it — leaving the SPA and losing unsaved work
 * (a half-written comment, a task description). Installed once at startup: drags of files that no drop zone accepted
 * (none called `preventDefault`, see `useFileUploads` / the rich text editor) are refused. Returns the uninstaller.
 */
export function installFileDropGuard(target: Window = window): () => void {
  const carriesFiles = (event: DragEvent) => event.dataTransfer?.types.includes('Files') ?? false;

  const onDragOver = (event: DragEvent) => {
    if (event.defaultPrevented || !carriesFiles(event)) return;
    event.preventDefault();
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'none';
  };
  const onDrop = (event: DragEvent) => {
    if (event.defaultPrevented || !carriesFiles(event)) return;
    event.preventDefault();
  };

  target.addEventListener('dragover', onDragOver);
  target.addEventListener('drop', onDrop);
  return () => {
    target.removeEventListener('dragover', onDragOver);
    target.removeEventListener('drop', onDrop);
  };
}
